import { render } from "./widget_part.vue?vue&type=template&id=4f56fc16&scoped=true"
import script from "./widget_part.vue?vue&type=script&lang=js"
export * from "./widget_part.vue?vue&type=script&lang=js"

import "./widget_part.vue?vue&type=style&index=0&id=4f56fc16&scoped=true&lang=css"

import exportComponent from "D:\\Users\\User\\Documents\\_PROJECTS\\VUE.JS\\tulmash\\web_widgets\\calc_auger\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f56fc16"]])

export default __exports__